"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _pageContext = require("../page-context");

/* eslint-disable react/display-name */
const Link = _react.default.forwardRef((_ref, ref) => {
  let {
    to
  } = _ref,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["to"]);
  const {
    lang
  } = (0, _pageContext.usePageContext)();
  return /*#__PURE__*/_react.default.createElement(_gatsby.Link, (0, _extends2.default)({}, rest, {
    ref: ref,
    to: lang ? `/${lang}${to}` : to
  }));
});

var _default = Link;
exports.default = _default;